import React from 'react';
import { getEventColor } from '../../utils/event.utils';
import '../../styles/Event/EventName.scss';

const EventName = ({ eventName, wrap = true }) => {
  let name;

  if (wrap) {
    name = eventName.split('_').map((part, index, parts) => (
      <React.Fragment key={index}>
        {part}
        {index < parts.length - 1 ? (
          <>
            _
            <wbr />
          </>
        ) : null}
      </React.Fragment>
    ));
  } else {
    name = eventName;
  }

  return (
    <div className="hp-event-name-wrap" style={{ color: getEventColor(eventName) }}>
      <div className="hp-event-name-indicator" />
      <div className="hp-event-name">{name}</div>
    </div>
  );
};

export default EventName;
